import React from "react";
import { formFieldTypeSingleLineText } from "../../constants/enum";
import { FORM_MODE_CREATE, FORM_MODE_UPDATE } from "../../constants/constants";
import { useDispatch, useSelector } from "react-redux";
import {
  selectFormByFormNameIsOpen,
  selectFormByFormNameMode,
} from "../../selectors/selectors";
import {
  TYPE_PAYMENT_ORDER_TYPE,
  useCreatePaymentOrderTypeMutation,
  useUpdatePaymentOrderTypeMutation,
} from "../../api/api";
import { appSnackbarAdd, formSet } from "../../actions/appActions";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { AddCircle, Save } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import FormField from "../Form/FormField";
import { store } from "../../store";

const formName = TYPE_PAYMENT_ORDER_TYPE;

const getFormFields = (mode) => {
  const fields = {};
  fields.title = {
    formFieldType: formFieldTypeSingleLineText,
    label: "Název",
    fullWidth: true,
    // error: validate && !validator.fieldValid("title"),
    //     helperText:
    // validate && !validator.fieldValid("title")
    //     ? validator.getErrorMessages()["title"]
    //     : null,
  };
  fields.code = {
    formFieldType: formFieldTypeSingleLineText,
    label: "Kód",
    fullWidth: true,
    // error: validate && !validator.fieldValid("title"),
    //     helperText:
    // validate && !validator.fieldValid("title")
    //     ? validator.getErrorMessages()["title"]
    //     : null,
  };

  return fields;
};

const PaymentOrderTypeDetail = () => {
  const dispatch = useDispatch();

  const open = useSelector((state) =>
    selectFormByFormNameIsOpen(state, { formName })
  );
  const mode = useSelector((state) =>
    selectFormByFormNameMode(state, { formName })
  );

  const [create, createResult] = useCreatePaymentOrderTypeMutation();
  const [update, updateResult] = useUpdatePaymentOrderTypeMutation();

  const handleClose = () => {
    dispatch(formSet(formName, null));
  };

  const [errors, setErrors] = React.useState({});

  // const validateForm = () => {
  //   const errors = {};
  //   let isValid = true;
  //   for (let memberField of memberFields) {
  //     if (
  //       memberField.required &&
  //       (!form.hasOwnProperty(memberField.id) ||
  //         form[memberField.id].trim() === "")
  //     ) {
  //       errors[memberField.id] = "Toto pole je povinné.";
  //       isValid = false;
  //     }
  //   }
  //   setErrors(errors);
  //
  //   return isValid;
  // };

  const handleSubmit = () => {
    const form = store.getState().app.forms[formName];

    if (mode === FORM_MODE_CREATE) {
      create({ body: form });
    }
    if (mode === FORM_MODE_UPDATE) {
      update({ body: form, id: form.id });
    }
  };

  const disabled = updateResult.isLoading || createResult.isLoading;

  React.useEffect(() => {
    if (
      !!createResult &&
      !createResult.isLoading &&
      !createResult.isError &&
      createResult.isSuccess
    ) {
      dispatch(
        appSnackbarAdd({
          message: "Typ předpisu platby byl vytvořen.",
          variant: "success",
        })
      );
      handleClose();
    }
    if (
      !!createResult &&
      !createResult.isLoading &&
      createResult.isError &&
      !createResult.isSuccess
    ) {
      dispatch(
        appSnackbarAdd({
          message: "Typ předpisu platby nebyl vytvořen.",
          variant: "error",
        })
      );
    }
  }, [createResult]);

  React.useEffect(() => {
    if (
      !!updateResult &&
      !updateResult.isLoading &&
      !updateResult.isError &&
      updateResult.isSuccess
    ) {
      dispatch(
        appSnackbarAdd({
          message: "Typ předpisu platby byl upraven.",
          variant: "success",
        })
      );
      handleClose();
    }
    if (
      !!updateResult &&
      !updateResult.isLoading &&
      updateResult.isError &&
      !updateResult.isSuccess
    ) {
      dispatch(
        appSnackbarAdd({
          message: "Typ předpisu platby nebyl upraven.",
          variant: "error",
        })
      );
    }
  }, [updateResult]);

  return (
    <>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>
          {mode === FORM_MODE_CREATE
            ? "Vytvořit typ předpisu platby"
            : "Upravit typ předpisu platby"}
          <IconButton
            sx={(theme) => {
              return {
                position: "absolute",
                right: 8,
                top: 8,
                color: theme.palette.grey[500],
              };
            }}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {open && (
            <>
              {Object.entries(getFormFields(mode)).map((v) => {
                const [name, field] = v;
                return (
                  <FormField
                    key={name}
                    formName={formName}
                    name={name}
                    {...field}
                  />
                );
              })}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleSubmit}
            color="primary"
            variant="contained"
            disableElevation
            startIcon={mode === FORM_MODE_CREATE ? <AddCircle /> : <Save />}
            disabled={disabled}
          >
            {mode === FORM_MODE_CREATE
              ? "Vytvořit typ předpisu platby"
              : "Upravit typ předpisu platby"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PaymentOrderTypeDetail;
